import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminLayout from './components/layout/AdminLayout.tsx';
import { TableSkeleton } from './components/shared/LoadingSkeleton.tsx';
import { ADMIN_PATHS } from '../routing/adminPaths.ts';
// ADMIN_PATHS.PLATFORM_SETTINGS is used below for the platform settings route.
import NotFoundPage from '../components/NotFoundPage';

// Lazy load pages (explicit .tsx for webpack resolution). Vendors removed.
const Dashboard = lazy(() => import('./pages/Dashboard.tsx'));
const Users = lazy(() => import('./pages/Users.tsx'));
const Integrations = lazy(() => import('./pages/Integrations.tsx'));
const IntegrationTypes = lazy(() => import('./pages/IntegrationTypes.tsx'));
const Organizations = lazy(() => import('./pages/Organizations.tsx'));
const OrganizationDetail = lazy(() => import('./pages/OrganizationDetail.tsx'));
const UserDetail = lazy(() => import('./pages/UserDetail.tsx'));
const RoleAccess = lazy(() => import('./pages/RoleAccess.tsx'));
const AuditLog = lazy(() => import('./pages/AuditLog.tsx'));
const PlatformSettings = lazy(() => import('./pages/PlatformSettings.tsx'));
const SopVideos = lazy(() => import('./pages/SopVideos.tsx'));
const SopVideoDetail = lazy(() => import('./pages/SopVideoDetail.tsx'));
const AiUsage = lazy(() => import('./pages/AiUsage.tsx'));
const ModelCompare = lazy(() => import('./pages/ModelCompare.tsx'));
const dashboardSegment = ADMIN_PATHS.DASHBOARD.slice(1);
const organizationsSegment = ADMIN_PATHS.ORGANIZATIONS.slice(1);
const usersSegment = ADMIN_PATHS.USERS.slice(1);
const integrationsSegment = ADMIN_PATHS.INTEGRATIONS.slice(1);
const integrationTypesSegment = ADMIN_PATHS.INTEGRATION_TYPES.slice(1);
const roleAccessSegment = ADMIN_PATHS.ROLE_ACCESS.slice(1);
const auditLogSegment = ADMIN_PATHS.AUDIT_LOG.slice(1);
const platformSettingsSegment = ADMIN_PATHS.PLATFORM_SETTINGS.slice(1);
const sopVideosSegment = ADMIN_PATHS.SOP_VIDEOS.slice(1);
const aiUsageSegment = ADMIN_PATHS.AI_USAGE.slice(1);
const modelCompareSegment = ADMIN_PATHS.MODEL_COMPARE.slice(1);

const AdminRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="*" element={<AdminLayout />}>
        <Route
          index
          element={
            <Suspense fallback={<TableSkeleton rows={4} columns={4} />}>
              <Dashboard />
            </Suspense>
          }
        />
        <Route
          path={dashboardSegment}
          element={
            <Suspense fallback={<TableSkeleton rows={4} columns={4} />}>
              <Dashboard />
            </Suspense>
          }
        />
        <Route
          path={organizationsSegment}
          element={
            <Suspense fallback={<TableSkeleton rows={5} columns={5} />}>
              <Organizations />
            </Suspense>
          }
        />
        <Route
          path={`${organizationsSegment}/:id`}
          element={
            <Suspense fallback={<TableSkeleton rows={5} columns={4} />}>
              <OrganizationDetail />
            </Suspense>
          }
        />
        <Route
          path={usersSegment}
          element={
            <Suspense fallback={<TableSkeleton rows={5} columns={7} />}>
              <Users />
            </Suspense>
          }
        />
        <Route
          path={`${usersSegment}/:id`}
          element={
            <Suspense fallback={<TableSkeleton rows={5} columns={4} />}>
              <UserDetail />
            </Suspense>
          }
        />
        <Route
          path={integrationsSegment}
          element={
            <Suspense fallback={<TableSkeleton rows={5} columns={5} />}>
              <Integrations />
            </Suspense>
          }
        />
        <Route
          path={integrationTypesSegment}
          element={
            <Suspense fallback={<TableSkeleton rows={5} columns={5} />}>
              <IntegrationTypes />
            </Suspense>
          }
        />
        <Route
          path={roleAccessSegment}
          element={
            <Suspense fallback={<TableSkeleton rows={6} columns={4} />}>
              <RoleAccess />
            </Suspense>
          }
        />
        <Route
          path={auditLogSegment}
          element={
            <Suspense fallback={<TableSkeleton rows={8} columns={6} />}>
              <AuditLog />
            </Suspense>
          }
        />
        <Route
          path={platformSettingsSegment}
          element={
            <Suspense fallback={<TableSkeleton rows={3} columns={2} />}>
              <PlatformSettings />
            </Suspense>
          }
        />
        <Route
          path={sopVideosSegment}
          element={
            <Suspense fallback={<TableSkeleton rows={5} columns={6} />}>
              <SopVideos />
            </Suspense>
          }
        />
        <Route
          path={`${sopVideosSegment}/:id`}
          element={
            <Suspense fallback={<TableSkeleton rows={5} columns={4} />}>
              <SopVideoDetail />
            </Suspense>
          }
        />
        <Route
          path={aiUsageSegment}
          element={
            <Suspense fallback={<TableSkeleton rows={6} columns={6} />}>
              <AiUsage />
            </Suspense>
          }
        />
        <Route
          path={modelCompareSegment}
          element={
            <Suspense fallback={<TableSkeleton rows={6} columns={4} />}>
              <ModelCompare />
            </Suspense>
          }
        />
        <Route
          path="*"
          element={<NotFoundPage />}
        />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
